import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import AddZoneTrainerModal from "../Modals/ZoneTrainers/AddZoneTrainers";
import EditZoneTrainerModal from "../Modals/ZoneTrainers/EditZoneTrainersAdmin";
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { AiOutlineAim, AiOutlineEye } from "react-icons/ai";
import { FaFacebook, FaInstagram, FaYoutube, FaLinkedin } from "react-icons/fa";

const ZoneTrainersPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [trainersPerPage] = useState(10);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [trainers, setTrainers] = useState([
    {
      id: 1,
      zoneName: "Zone XVIII (18)",
      name: "John Doe",
      localOrg: "JCI Example",
      highestPortfolio: "President",
      year: "2023",
      dob: "1995-01-01",
      qualification: "Graduated",
      whatsapp: "9876543210",
      contactNumber: "9876543210",
      instagram: "john_doe_insta",
      district_name: "Kanyakumari",
      graduated: "Yes",
      graduatedYear: "2016",
      loLevelTrainings: 20,
      corporateTrainings: 5,
      zone_trainer_id: "",
      trainingsOffered: {
        jciOrientation: true,
        effectivePublicSpeaking: false,
        empoweringYouth: true,
        futureLeaders: false,
        leaderTrainingSeries: true,
        loIdTraining: false,
        businessTrainings: true,
        industrialTrainings: false,
        institutionalTrainings: false,
        others: "",
      },
      trainingSpecialization: "Public Speaking, Leadership",
      photo: null,
    },
  ]);
  const [profileImage, setProfileImage] = useState(null);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);
  const filteredTrainers = trainers.filter(
    (trainer) =>
      trainer.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      trainer.jci_membership_id
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      trainer.lom_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      trainer.district_name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastTrainer = currentPage * trainersPerPage;
  const indexOfFirstTrainer = indexOfLastTrainer - trainersPerPage;
  const currentTrainers = filteredTrainers.slice(
    indexOfFirstTrainer,
    indexOfLastTrainer
  );

  const handleAddTrainer = (data) => {
    setTrainers([...trainers, { id: trainers.length + 1, ...data }]);
    toggleModal();
  };

  const handleEditTrainer = (data) => {
    setTrainers(
      trainers.map((trainer) =>
        trainer.id === data.id ? { ...trainer, ...data } : trainer
      )
    );
    toggleEditModal();
  };

  const handleDeleteTrainer = async (zone_trainer_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Send the trainer ID to the backend for deletion
          await axios.delete(
            `/zone_trainer/delete_zone_trainer/${zone_trainer_id}`
          );

          // Remove the deleted trainer from the state
          setTrainers(
            trainers.filter(
              (trainer) => trainer.zone_trainer_id !== zone_trainer_id
            )
          );

          Swal.fire("Deleted!", "Your record has been deleted.", "success");
        } catch (error) {
          Swal.fire(
            "Error!",
            error.response?.data?.error || "Something went wrong",
            "error"
          );
        }
      }
    });
  };

  const openEditModal = (record) => {
    setSelectedRecord(record);
    toggleEditModal();
  };

  const openViewModal = (trainer) => {
    console.log(trainer);
    setSelectedTrainer(trainer);
    setIsViewModalOpen(true);
  };

  const closeViewModal = () => {
    setSelectedTrainer(null);
    window.location.reload(); // Reload the page after successful insertion
    setIsModalOpen(false);
  };

  const fetchZoneTrainers = async () => {
    try {
      const response = await axios.get("/member/get_all_zone_trainers");
      console.log(response.data);
      setTrainers(response.data); // Assuming the API returns combined member and trainer data
    } catch (error) {
      console.error("Error fetching zone trainers:", error);
    }
  };

  const [userRole, setuserRole] = useState("");

  useEffect(() => {
    fetchZoneTrainers();
    const profession_id = sessionStorage.getItem("profession_id");
    if (profession_id) {
      setuserRole(profession_id);
    }
  }, []);

  useEffect(() => {
    const url = sessionStorage.getItem("url");
    setProfileImage(url);
  }, []);

  const trainingNames = [
    "JCI Orientation",
    "Effective Public Speaking",
    "Empowering Youth",
    "Future Leadership",
    "Leader Training Series",
    "LoId Training",
    "Business Trainings",
    "Industrial Trainings",
    "Institutional Trainings",
    "Others",
  ];

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); // Ensures 2 digits for the day
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensures 2 digits for the month (Months are 0-indexed)
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <div className="mb-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Zone Trainers</h1>

            <button
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              onClick={toggleModal}
            >
              Add Zone Trainer
            </button>
          </div>
          <div className="mb-4 flex justify-end">
            <input
              type="text"
              placeholder="Search trainers..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="border rounded-md px-4 py-2 w-64"
            />
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse">
              <thead>
                <tr>
                  <th className="border px-4 py-2">MemberId</th>
                  <th className="border px-4 py-2">Profile</th>
                  <th className="border px-4 py-2">Trainer Name</th>
                  <th className="border px-4 py-2">Zone18</th>
                  <th className="border px-4 py-2">LO</th>
                  <th className="border px-4 py-2">District</th>
                  <th className="border px-4 py-2">Contact Number</th>
                  <th className="border px-4 py-2">View</th>
                  <th className="border px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentTrainers.map((trainer) => (
                  <tr key={trainer.member_id}>
                    <td className="border px-4 py-2">
                      {trainer.jci_membership_id}
                    </td>
                    <td className="border px-4 py-2">
                      <img
                        src={
                          trainer.images
                            ? `${profileImage}/member/zone_trainers_images/${trainer.images}`
                            : "/default_avatar.png"
                        }
                        alt={trainer.name}
                        className="w-12 h-12 rounded-full object-cover border border-gray-300 mr-2"
                      />
                    </td>
                    <td className="border px-4 py-2">{trainer.name}</td>
                    <td className="border px-4 py-2">
                      {trainer.trainer_from_zone_18}
                    </td>
                    <td className="border px-4 py-2">
                      {trainer.lom_name || "N/A"}
                    </td>
                    <td className="border px-4 py-2">
                      {trainer.district_name}
                    </td>
                    <td className="border px-4 py-2">
                      {trainer.contact_number}
                    </td>
                    <td className="border px-4 py-2 text-center">
                      <AiOutlineEye
                        className="text-nav-bg-primary text-xl cursor-pointer hover:text-nav-bg-secondary"
                        onClick={() => openViewModal(trainer)}
                      />
                    </td>
                    <td className="border px-4 py-2 text-center flex">
                      <FaPen
                        className="text-amber-400 mt-6 text-lg cursor-pointer"
                        onClick={() => openEditModal(trainer)}
                      />
                      <MdDeleteForever
                        className="ml-2 mt-5 mb-2 text-red-500 text-2xl cursor-pointer"
                        onClick={() =>
                          handleDeleteTrainer(trainer.zone_trainer_id)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-center mt-4">
            {Array.from(
              { length: Math.ceil(filteredTrainers.length / trainersPerPage) },
              (_, index) => (
                <button
                  key={index}
                  onClick={() => paginate(index + 1)}
                  className={`px-4 py-2 mx-1 border ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-white"
                  }`}
                >
                  {index + 1}
                </button>
              )
            )}
          </div>
          {setIsViewModalOpen && selectedTrainer && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-8 rounded-lg shadow-lg max-w-4xl w-full md:w-1/2 lg:w-1/3 max-h-[90vh] overflow-auto">
                {/* Header Section with Image and Name */}
                <div className="flex items-center space-x-4 mb-6">
                  <img
                    src={
                      selectedTrainer.images
                        ? `${profileImage}/member/zone_trainers_images/${selectedTrainer.images}`
                        : "/default_avatar.png"
                    }
                    alt={`${selectedTrainer.name} Avatar`}
                    className="w-20 h-20 rounded-full object-cover border-4 border-x-neutral-50"
                  />
                  <div>
                    <h2 className="text-2xl font-semibold text-gray-800">
                      {selectedTrainer.name}
                    </h2>
                    <p className="text-sm text-gray-500">
                      {selectedTrainer.lom_name || "N/A"}
                    </p>
                  </div>
                </div>
                <div className="mb-5">
                  <hr />
                </div>

                {/* Contact and Status Section */}
                <div className="space-y-4">
                  <h5 className="text-sm font-semibold text-nav-bg-primary">
                    Trainer Information
                  </h5>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Member ID: {selectedTrainer.jci_membership_id}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      District: {selectedTrainer.district_name}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Highest Portfolio & year:{" "}
                      {selectedTrainer.highest_portfolio} -{" "}
                      {selectedTrainer.portfolio_year}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Highest Position of Training:{" "}
                      {selectedTrainer.highest_position_training}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Number of LO Level Trainings:{" "}
                      {selectedTrainer.no_of_lo_level_trainings}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Number of Corporate Trainings:{" "}
                      {selectedTrainer.no_of_corporate_trainings}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Trainings I Would Love to Offer:{" "}
                      {selectedTrainer.selectedTrainingIds
                        ? selectedTrainer.selectedTrainingIds
                            .split(",") // Split the string into an array (e.g., '1,2' => ['1', '2'])
                            .map((id) => trainingNames[parseInt(id) - 1]) // Subtract 1 from ID to match the correct index in the array
                            .join(", ") // Join them into a comma-separated list
                        : "-"}
                    </span>
                  </div>

                  <div className="mb-5">
                    <hr />
                  </div>
                  <h5 className="text-sm font-semibold text-nav-bg-primary">
                    Education Details
                  </h5>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Education Qualification:{" "}
                      {selectedTrainer.education_qualification}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Graduation Year:{" "}
                      <span className="text-gray-600">
                        {selectedTrainer.graduated_year}
                      </span>
                    </span>
                  </div>

                  <div className="mb-5">
                    <hr />
                  </div>
                  <h5 className="text-sm font-semibold text-nav-bg-primary">
                    Personal Details
                  </h5>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Date of Birth:{" "}
                      {selectedTrainer.dob
                        ? formatDate(selectedTrainer.dob)
                        : "-"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      WhatsApp Number:{" "}
                      <span className="text-gray-600">
                        {selectedTrainer.whatsapp_number}
                      </span>
                    </span>
                  </div>

                  <div className="mb-5">
                    <hr />
                  </div>
                  <h5 className="text-sm font-semibold text-nav-bg-primary">
                    Address & Social Media Details
                  </h5>
                  <div className="flex justify-between">
                    <span className="text-xs text-gray-700">
                      Address: {selectedTrainer.address}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    {/* Social Media Icons */}

                    {selectedTrainer.facebook ||
                    selectedTrainer.instagram ||
                    selectedTrainer.youtube ||
                    selectedTrainer.linkedin ? (
                      <div>
                        {" "}
                        <div className="flex space-x-2">
                          <a
                            href={selectedTrainer.facebook || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {selectedTrainer.facebook ? (
                              <FaFacebook
                                className={`text-blue-500 ${
                                  !selectedTrainer.facebook &&
                                  "opacity-50 cursor-pointer"
                                }`}
                              />
                            ) : (
                              []
                            )}
                          </a>
                          <a
                            href={selectedTrainer.instagram || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {selectedTrainer.instagram ? (
                              <FaInstagram
                                className={`text-red-800 ${
                                  !selectedTrainer.instagram &&
                                  "opacity-50 cursor-pointer"
                                }`}
                              />
                            ) : (
                              []
                            )}
                          </a>
                          <a
                            href={selectedTrainer.youtube || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            {selectedTrainer.youtube ? (
                              <FaYoutube
                                className={`text-red-500 ${
                                  !selectedTrainer.youtube &&
                                  "opacity-50 cursor-pointer"
                                }`}
                              />
                            ) : (
                              []
                            )}
                          </a>
                          <a
                            href={selectedTrainer.linkedin || "/login"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {selectedTrainer.linkedin ? (
                              <FaLinkedin
                                className={`text-blue-700 ${
                                  !selectedTrainer.linkedin &&
                                  "opacity-50 cursor-pointer"
                                }`}
                              />
                            ) : (
                              []
                            )}
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div>-</div>
                    )}
                  </div>
                </div>

                {/* Close Button */}
                <div className="flex justify-center mt-6">
                  <button
                    className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition-all duration-200"
                    onClick={closeViewModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <AddZoneTrainerModal
        show={isModalOpen}
        onClose={toggleModal}
        onSubmit={handleAddTrainer}
      />
      {isEditModalOpen && selectedRecord && (
        <EditZoneTrainerModal
          show={isEditModalOpen}
          onClose={toggleEditModal}
          onSubmit={handleEditTrainer}
          initialData={selectedRecord}
        />
      )}
    </div>
  );
};

export default ZoneTrainersPage;
